import { buildProps, definePropType } from '@ll-plus/utils'

import type { FormColumn, FormData } from './form'

export const formComponentProps = buildProps({
  /**
   * @description 表单项列表
   */
  item: {
    type: definePropType<FormColumn>(Object),
    default: () => ({}),
  },

  /**
   * @description 展开的行变化时触发
   */
  formData: {
    type: definePropType<FormData>(Object),
    default: () => ({}),
  },
} as const)

export const formComponentEmits = {
  changeField: (item: FormColumn) => !!item,
  blurField: (item: FormColumn) => !!item,
} as const
